import { addTagDelete, helperDoc, processDownload, processExpand, processExpandHover, processImgDelete, processNotes, processReplace, processZoom, processZoomHover } from 'assets/icons';
import axios from 'axios';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { OverlayPanel } from 'primereact/overlaypanel';
import React, { useRef, useState } from 'react';
import * as myconst from "../../constants";
import _isEqual from 'lodash/isEqual';
import { useSearchParams } from 'react-router-dom';
interface ImageData {
    conversation_id: string,
    input_image_id: string,
    output_image_id: string[],
    user_name: string,
    image_extension: string,
    input_path: string,
    output_path: string[],
    system_prompt: string,
    notes: string,
    tag: string[],
    created_at: string,
    is_save: boolean
}interface ProcessType {
    isImageHistory: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    handleToggle: () => void;
    activeImage: string;
    setActiveImage: React.Dispatch<React.SetStateAction<string>>;
    imageData: ImageData;
    setSaveCurrentInputValue: React.Dispatch<React.SetStateAction<string>>;
    saveCurrentInputValue: string;
    setCurrentTagValue: React.Dispatch<React.SetStateAction<string>>;
    currentTagValue: string;
    setCurrentTagList: React.Dispatch<React.SetStateAction<string[]>>;
    currentTagList: string[];
    editTagNotes: () => Promise<void>;
    setActiveClassImage: React.Dispatch<React.SetStateAction<number>>;
    activeClassImage: number;
    componentName: string;
    preSaveCurrentInputValue: string
    preCurrentTagList: string[]
}

const ProcessSection = ({ preCurrentTagList, preSaveCurrentInputValue, isImageHistory, setVisible, handleToggle, activeImage, setActiveImage, imageData, setSaveCurrentInputValue, saveCurrentInputValue, setCurrentTagValue, currentTagValue, currentTagList, setCurrentTagList, editTagNotes, setActiveClassImage, activeClassImage, componentName }: ProcessType) => {
    const [zoomHover, setZoomHover] = useState(processZoom);
    const [expandHover, setExpandHover] = useState(processExpand);
    const [searchParams] = useSearchParams();
    const imageId: string | null = searchParams.get('input_image_id');
    const [scale, setScale] = useState(100); // initial scale is 100%
    const zoomIn = () => {
        setScale(prevScale => Math.min(prevScale + 10, 160)); // cap at 250%
    };

    const zoomOut = () => {
        setScale(prevScale => Math.max(prevScale - 10, 60)); // floor at 80%
    };

    const op: any = useRef(null);
    const oe: any = useRef(null);

    const handleUpdateTag = async () => {
        op.current.hide();
        await editTagNotes();
    }


    const downloadImage = async (imageUrl: string) => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = "images";
            // link.download = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up the URL.createObjectURL reference
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading the image:', error);
        }
    };
    const apiUrl = process.env.RON_LENS_IMAGE || (window.location.origin === 'https://ron.rysun.in:3001' || window.location.origin === 'https://shoptalk.rysun.com') ? "https://ronimages.rysun.in/" : 'http://43.242.38.46/';
    const disableCheck = () => {
        if (preSaveCurrentInputValue === saveCurrentInputValue && _isEqual(preCurrentTagList, currentTagList)) {
            return true
        } else {
            return false
        }
    }
    return (
        <div className={isImageHistory ? "process-image-body show" : "process-image-body"}>
            <div className='process-actions'>
                <ul className='process-left-actions'>
                    {imageId !== null && imageId !== "original" &&
                        <li onClick={() => downloadImage(activeImage)}>
                            <span><i><img src={processDownload} alt="process-download" /></i>Download</span>
                        </li>
                    }
                    {/* <li>
                        <span><i><img src={processReplace} alt="process-notes" /></i>Replace Product</span>
                    </li> */}
                    {imageData.is_save && imageData.system_prompt !== "" &&
                        <li>
                            <span onClick={(e) => op.current.toggle(e)}><i><img src={processNotes} alt="process-replace" /></i>Notes & Tag</span>
                            <OverlayPanel ref={op} className='radius-overlay' onHide={() => { setCurrentTagValue(""); setCurrentTagList(preCurrentTagList); setSaveCurrentInputValue(preSaveCurrentInputValue) }}>
                                <div className="add-tag-dialog">
                                    <div className="add-tag-header">
                                        <span className="p-dialog-title">Add tag and notes to Generated Image</span>
                                        {/* <div className="add-tag-header-action">
                                            <i><img src={addTagDelete} alt="process-replace" /></i>
                                            <i><img src={processImgDelete} alt='delete-icon' /></i>
                                        </div> */}
                                    </div>
                                    <div className="add-tag-row">
                                        <label>Add Tag</label>
                                        <InputText disabled={currentTagList.length > 2} value={currentTagValue} onKeyDown={(e: any) => { if (e.key === 'Enter') { myconst.handleTagList(currentTagValue, currentTagList, setCurrentTagList, setCurrentTagValue) } }} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCurrentTagValue(e.target.value)} placeholder="Add tag" />
                                        <Button disabled={currentTagList.length > 2} style={{ opacity: currentTagList.length > 2 ? "0.5" : "1" }} label="Add" className="btn-primary" onClick={() => myconst.handleTagList(currentTagValue, currentTagList, setCurrentTagList, setCurrentTagValue)} />
                                        <ul className="tags-list">
                                            {currentTagList.map((tag: string, index: number) => (
                                                <li key={index}>
                                                    <span>{tag}<i className="pi pi-times" onClick={() => myconst.handleClearTag(tag, currentTagList, setCurrentTagList)}></i></span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="add-tag-row">
                                        <label>Add Notes</label>
                                        <InputTextarea value={saveCurrentInputValue} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setSaveCurrentInputValue(e.target.value)} placeholder="Describe your experience here" />
                                    </div>
                                    <div className="add-tag-footer">
                                        <Button label="Save" disabled={disableCheck()} onClick={handleUpdateTag} className="outline-active-btn" />
                                    </div>
                                </div>
                            </OverlayPanel>
                        </li>
                    }
                </ul>
                <ul className='process-right-actions'>
                    <li><button type="button" disabled={imageData?.is_save || imageData?.conversation_id === ""} className={`btn-primary rounded-0 mr-3 ${(imageData?.is_save || imageData?.conversation_id === "") ? "process-btn-disabled" : ""}`} onClick={() => setVisible(true)} >Save</button></li>
                    {activeImage !== "" && activeImage !== 'data:undefined;base64,' && <>
                        <li>
                            <i onClick={(e) => oe.current.toggle(e)} onMouseEnter={() => setZoomHover(processZoomHover)} onMouseLeave={() => setZoomHover(processZoom)}>
                                <img src={zoomHover} alt="process-zoom" />
                            </i>
                            <OverlayPanel ref={oe} className='radius-overlay'>
                                <div className="zoom-overlay">
                                    <ul className="zoom-list">
                                        <li><b>{scale}%</b></li>
                                        <li><span onClick={zoomOut} className={`zoom-btn pi pi-minus ${scale === 60 ? "disabled" : ""}`}></span><span onClick={zoomIn} className={`zoom-btn pi pi-plus ${scale === 160 ? "disabled" : ""}`}></span></li>
                                        <li><Button onClick={() => setScale(100)} label="Reset" className="outline-icon-btn" /></li>
                                    </ul>
                                </div>
                            </OverlayPanel>
                        </li>
                        <li>
                            <i onClick={handleToggle} onMouseEnter={() => setExpandHover(processExpandHover)} onMouseLeave={() => setExpandHover(processExpand)}>
                                <img src={expandHover} alt="process-expand" />
                            </i>
                        </li>
                    </>}
                </ul>
            </div>
            <div className='process-image-wrap'>
                {activeImage !== "" && activeImage !== 'data:undefined;base64,' &&
                    <div className="lens-img-wrap">
                        <img src={activeImage} style={{ transform: `scale(${scale / 100})`, transition: 'transform 0.2s ease' }} alt='lens-img-main' />
                        {/* <img src={`${process.env.RON_LENS_IMAGE}${activeImage}`} style={{ transform: `scale(${scale / 100})`, transition: 'transform 0.2s ease' }} alt='lens-img-main' /> */}
                    </div>
                }
                {componentName !== "ron_lens_instance_change" &&
                    <div className='lens-img-row'>
                        {imageData?.output_path[0] !== "" && imageData?.output_path.length > 2 &&
                            <ul className='lens-img-list'>
                                {imageData?.output_path?.map((img: string, i: number) => (
                                    <li className={activeClassImage === i ? "lens-img-active" : ''} key={i} onClick={() => { myconst.imageToBase64(img.replace("/var/www/html/", apiUrl), setActiveImage); setActiveClassImage(i); }}>
                                        {/* <li className={activeImage === img ? "lens-img-active" : ''} key={i} onClick={() => setActiveImage(img.replace("/var/www/html/", apiUrl))}> */}
                                        <span><img src={img?.replace("/var/www/html/", apiUrl)} alt='lens-img' /></span>
                                    </li>
                                ))}
                            </ul>
                        }
                    </div>
                }
            </div>
            {/* <p className='helper-text process-helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i>Image history will be erased within the next 7 days.</p> */}
        </div>
    )
}

export default ProcessSection